import React from "react";
import { FormattedMessage, FormattedHTMLMessage, useIntl } from "react-intl";

import Seo from "../../../common/helpers/seo";

import Tabs from "../../components/Tabs";
import Icon from "../../icon";
import NewHomeworkModal from "../../pages/plan/NewHomeworkModal/NewHomeworkModal";
import ResultTable from "../../pages/homework-result/ResultTable";
import Menu from "../../pages/plan/Menu/Menu";
import UpperRow from "../../pages/plan/UpperRow/UpperRow";
import ConnectModal from "../../pages/play-plan/ConnectModal/ConnectModal";

import { StyledArticle, P1, P2, H3, H2 } from "../styles";

import VirtualSolveInClass from "./VirtualSolveInClass";

import {
    StyledSpring,
    StyledCenter,
    Image,
    Alert,
    BigIcon,
    Way,
    WayWrapper,
    StyledForm,
    StyledSection,
    StyledTexts,
    Advice,
    MenuWrapper,
    SimpleWaysWrapper,
    ConnectWrapper,
} from "./styles";

import messages from "./messages";
import homeworkResults from "./data";
import imageUrl from "./image";
import { IUser } from "../../store/user/models";

const Covid = () => {
    const intl = useIntl();
    const { formatMessage, locale } = intl;
    return (
        <StyledSpring withShadow marginTop={50}>
            <Seo
                title={formatMessage(messages.title)}
                type={"article"}
                description={formatMessage(messages.p1)}
                image={imageUrl}
            />
            <StyledArticle>
                <StyledCenter>
                    <H2>
                        <FormattedMessage {...messages.title} />
                    </H2>
                    <P1>
                        <FormattedMessage {...messages.p1} />
                    </P1>
                </StyledCenter>
            </StyledArticle>
            <StyledArticle>
                <StyledCenter>
                    <Alert>
                        <Icon i="alert" /> <FormattedMessage {...messages.alert1} />
                    </Alert>
                </StyledCenter>
            </StyledArticle>
            <Image src={imageUrl} />
            <StyledArticle dark>
                <StyledCenter>
                    <H2 dark>
                        <BigIcon>
                            <Icon i="homework" />
                        </BigIcon>{" "}
                        <FormattedMessage {...messages.title2} />
                    </H2>
                    <P1 dark>
                        <FormattedMessage {...messages.p2} />
                    </P1>
                    <WayWrapper>
                        <Way>
                            <BigIcon>
                                <Icon i="meta" />
                            </BigIcon>
                        </Way>
                        <P2 dark>
                            <FormattedMessage {...messages.li1} />
                        </P2>
                    </WayWrapper>
                    <WayWrapper isLast>
                        <Way>
                            <BigIcon>
                                <Icon i="browse" />
                            </BigIcon>
                        </Way>
                        <P2 dark>
                            <FormattedHTMLMessage {...messages.li2} />
                        </P2>
                    </WayWrapper>
                </StyledCenter>
            </StyledArticle>
            <StyledArticle light>
                <H3>
                    <FormattedMessage {...messages.h2} />
                </H3>
                <StyledSection>
                    <StyledTexts>
                        <MenuWrapper>
                            <Menu
                                type="public"
                                notLoggedIn={false}
                                plan={homeworkResults.plan}
                                isCovid
                                publicView
                                simulation
                            />
                        </MenuWrapper>
                        <P1>
                            <FormattedMessage {...messages.p3} />
                        </P1>
                        <P1>
                            <FormattedMessage {...messages.p4} />
                        </P1>
                    </StyledTexts>
                    <StyledForm>
                        <NewHomeworkModal
                            isSimulation
                            tasks={[]}
                            planId="0"
                        />
                    </StyledForm>
                    <ResultTable {...homeworkResults} isSimulation />
                </StyledSection>
                <Advice>
                    <Icon i="alert" /> <FormattedMessage {...messages.tip} />
                </Advice>
                <P2 center>
                    <FormattedMessage {...messages.p5} />
                </P2>
            </StyledArticle>
            <StyledArticle dark>
                <StyledCenter>
                    <H2 dark>
                        <BigIcon>
                            <Icon i="whiteboard" />
                        </BigIcon>{" "}
                        <FormattedMessage {...messages.title3} />
                    </H2>
                    <P1 dark>
                        <FormattedHTMLMessage {...messages.d1} />
                    </P1>
                    <SimpleWaysWrapper>
                        <section>
                            <div>
                                <Way>
                                    <BigIcon>
                                        <Icon i="meta" />
                                    </BigIcon>
                                </Way>
                                <P2 dark>
                                    <FormattedMessage {...messages.li3} />
                                </P2>
                            </div>
                            <div>
                                <Way>
                                    <BigIcon>
                                        <Icon i="browse" />
                                    </BigIcon>
                                </Way>
                                <P2 dark>
                                    <FormattedMessage {...messages.li4} />
                                </P2>
                            </div>
                        </section>
                    </SimpleWaysWrapper>
                </StyledCenter>
            </StyledArticle>
            <StyledArticle light>
                <H3>
                    <FormattedMessage {...messages.h2} />
                </H3>
                <StyledSection>
                    <StyledTexts className="inClass">
                        <MenuWrapper>
                            <UpperRow
                                plan={homeworkResults.plan}
                                isCovid
                                user={{ loggedIn: true, language: locale, profiled: true } as IUser}
                                publicView
                                simulation
                                notLoggedIn={false}
                                showTutorial={false}
                                toggleTutorial={() => null}
                            />
                        </MenuWrapper>
                        <P1>
                            <FormattedMessage {...messages.d2} />
                        </P1>
                        <P1>
                            <FormattedMessage {...messages.d3} />
                        </P1>
                        <P1>
                            <FormattedHTMLMessage {...messages.benefits} />
                        </P1>
                    </StyledTexts>
                    <section>
                        <Tabs lg autoPlay autoPlayTime={6000}>
                            {[
                                {
                                    title: formatMessage(messages.tab1),
                                    content: (
                                        <ConnectWrapper>
                                            <ConnectModal
                                                connectKey="1000"
                                                plan={homeworkResults.plan}
                                                students={homeworkResults.results}
                                                close={() => null}
                                                setClassId={() => null}
                                            />
                                        </ConnectWrapper>
                                    ),
                                },
                                {
                                    title: formatMessage(messages.tab2),
                                    content: (
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <VirtualSolveInClass />
                                        </div>
                                    ),
                                },
                            ]}
                        </Tabs>
                    </section>
                </StyledSection>
                <Advice>
                    <Icon i="alert" /> <FormattedMessage {...messages.tip2} />
                </Advice>
            </StyledArticle>
        </StyledSpring>
    );
}

export default Covid;
